module.exports = __webpack_public_path__ + "img/shabake2.0d703dc8.jpg";